<template> 
        <div class="animated fadeIn">
            <b-overlay :show="loading" rounded="sm">

            <b-container fluid class="p-0">
                <b-card
                header="Menu Board"
                header-text-variant="light"
                header-tag="header"
                header-class="header-color"
                
                >
                    <h5 class="font-weight-bold">Menu Board TVs</h5>
                    <b-table-simple v-if="tvs.length" striped borderless responsive class="tv-table">
                        <b-thead>
                            <b-tr class="bg-gray-300">
                                <b-th>Menu Board TV Name</b-th>
                                <b-th>TV Link</b-th>
                                <b-th>Display Template</b-th>
                                <b-th></b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item,index) in tvs" :key="index">
                                <b-td class="tv-table-cell">
                                    <p class="mb-0">
                                        <p>{{item.TVname }} <span class="text-muted" style="font-size: 0.7rem;"> {{"(ID = " + item.TVid + ")"}}</span></p>
                                    </p>
                                </b-td>
                                <b-td class="tv-table-cell tv-link-cell">
                                    <a :href="getTVLink(item.Menuboard_URL)" :target="getTVLink(item.Menuboard_URL)" class="mb-0">
                                        <span>{{getTVLink(item.Menuboard_URL)}}</span>
                                    </a>
                                </b-td>
                                <b-td class="tv-table-cell">
                                    <p class="mb-0">
                                        <span>{{item.DisplayTemplate}}</span>
                                    </p>
                                </b-td>   
                                
                                
                                <b-td class="tv-table-cell">
                                    <font-awesome-icon icon="pencil-alt" class="align-middle mx-2 cursor-pointer" @click="showEditMode(item.TVid)"/>
                                </b-td>
                                
                            </b-tr>
                        </b-tbody>
                       
                    </b-table-simple>
                    <b-btn @click="showAddTV" variant="danger">
                        Add Menu Board TV
                        <font-awesome-icon icon="plus" class="align-middle mx-1"/>
                    </b-btn>
                    
                    



                   

                    <c-modal centered v-model="editTvMode" :tag="false" size="lg" title="Edit Menu Board TV">
                        <template>
                            <b-container>
                                <b-alert :show="errors.any()" variant="danger" class="px-4">
                                    <ul class="m-0 px-1">
                                        <li v-for="err in errors.all()" :key="err">{{err}}</li>
                                    </ul>
                                </b-alert>

                                <b-row class="mt-3">
                                    <b-input-group prepend="Menu Board TV Name" class="px-3">
                                            <b-form-input class="text-center" type="text" name="tv Name" v-validate="'required'" v-model="editTvModel.TVname"/>
                                        </b-input-group>
                                </b-row>
                                <b-row>
                                    
                                    <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                        <b-input-group prepend="Background Color" class="mt-3">
                                                <input type="color" v-model="editTvModel.BackgroundColor" class="backgroundColor" name="color" value="#ffffff" />
                                        </b-input-group>
                                        
                                        
                                            
                                    </b-col>
                                    
                                    <b-col cols="12" md="6" >
                                        <b-input-group prepend="Background Image" class="mt-3">
                                                <div v-if="editTvModel.BackgroundImage"@click="selectBackgroundImage" :style="{backgroundImage: 'url(' + getBackgroundImage(editTvModel.BackgroundImage) + ')'}" class="backgroundImage">
                                                    <img :src="getBackgroundImage(editTvModel.BackgroundImage)" class="backgroundImageThumbnail" />
                                                </div>
                                                <div v-else>
                                                    <b-btn variant="secondary" class="backgroundImageThumbnail" @click="selectBackgroundImage">Upload</b-btn>
                                                </div>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-3">
                                    <b-col cols="12" md="6" class="px-3 mb-3 mb-md-0">
                                        <Mlabel  title="Display Theme" >
                                        <span >{{ editTvModel.DisplayTemplate }}</span>
                                            <b-link class="ml-2" v-if="!showTemplateChange" @click="changeTemplateVisibility()"> Edit</b-link>
                                                            
                                                    <b-input-group prepend="Display Theme" v-if="showTemplateChange" >
                                                <b-form-select
                                                class="myFeild"
                                                v-model="editTvModel.DisplayTemplate"
                                                :options="themes"
                                                placeholder="Select"
                                                >
                                                <template #first>
                                                    <b-form-select-option :value="null||''">Select...</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                            </b-input-group>
                                        </Mlabel>
                                        
                                    </b-col>

                                    <b-col cols="12" md="6">
                                        <b-input-group prepend="Text Area Height(%)" >
                                                <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.TextAreaPercentage"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.TextAreaHeights"/>
                                            </b-input-group >

                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                
                                    <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                            <b-row class="ml-1 mt-2 mb-2 ">Category Name</b-row>  
                                        
                                            <b-input-group prepend="Font Name" class="mt-2">
                                                <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.Category_FontName"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontNames"/>
                                            </b-input-group >
                                            
                                            <b-input-group prepend="Font Style" class="mt-2">
                                            <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.Category_FontStyle"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontStyles"/>
                                            </b-input-group >
                                    </b-col>
                                    
                                    <b-col cols="12" md="6">
                                        <b-form-group>
                                            <b-row class="ml-1 mt-2 mb-2">‎ </b-row> <!-- invisible character in this line -->
                                           
                                            <b-input-group prepend="Font Size" class="mt-2">
                                                    <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.Category_FontSize"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontSizes"/>
                                            </b-input-group>
                                            <b-input-group prepend="Font Color" class="mt-2">
                                                <input type="color" v-model="editTvModel.Category_FontColor" id="color" name="color" value="#ffffff" />
                                            </b-input-group>

                                        </b-form-group>
                                    </b-col>
                               
                                </b-row> 
                                <b-row class="mt-2">
                                
                                    <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                            <b-row class="ml-1 mt-2 mb-2 ">Category Comment</b-row>  
                                        
                                            <b-input-group prepend="Font Name" class="mt-2">
                                                <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.CategoryComm_FontName"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontNames"/>
                                            </b-input-group >
                                            
                                            <b-input-group prepend="Font Style" class="mt-2">
                                            <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.CategoryComm_FontStyle"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontStyles"/>
                                            </b-input-group >
                                    </b-col>
                                    
                                    <b-col cols="12" md="6">
                                        <b-form-group>
                                            <b-row class="ml-1 mt-2 mb-2">‎ </b-row> <!-- invisible character in this line -->
                                           
                                            <b-input-group prepend="Font Size" class="mt-2">
                                                    <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.CategoryComm_FontSize"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontSizes"/>
                                            </b-input-group>
                                            <b-input-group prepend="Font Color" class="mt-2">
                                                <input type="color" v-model="editTvModel.CategoryComm_FontColor" id="color" name="color" value="#ffffff" />
                                            </b-input-group>

                                        </b-form-group>
                                    </b-col>
                               
                                </b-row> 
                                <b-row class="mt-2">
                                
                                    <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                            <b-row class="ml-1 mt-2 mb-2 ">Food/Drink Information</b-row>  
                                        
                                            <b-input-group prepend="Font Name" class="mt-2">
                                                <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.Food_FontName"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontNames"/>
                                            </b-input-group >
                                            
                                            <b-input-group prepend="Font Style" class="mt-2">
                                            <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.Food_FontStyle"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontStyles"/>
                                            </b-input-group >
                                    </b-col>
                                    
                                    <b-col cols="12" md="6">
                                        <b-form-group>
                                            <b-row class="ml-1 mt-2 mb-2">‎ </b-row> <!-- invisible character in this line -->
                                           
                                            <b-input-group prepend="Font Size" class="mt-2">
                                                    <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="editTvModel.Food_FontSize"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontSizes"/>
                                            </b-input-group>
                                            <b-input-group prepend="Font Color" class="mt-2">
                                                <input type="color" v-model="editTvModel.Food_FontColor" id="color" name="color" value="#ffffff" />
                                            </b-input-group>

                                        </b-form-group>
                                    </b-col>
                               
                                </b-row> 
                            </b-container>
                        </template>
                        <template #actions>
                            <b-row class="flex-grow-1">
                                <b-col cols="12" md="4" class="mb-2 mb-md-0">
                                    <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="editTV">
                                        Save change
                                        <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                                    </b-btn>
                                </b-col>
                                <b-col cols="12" md="4" class="mb-2 mb-md-0">
                                    <b-btn variant="danger" block class="text-nowrap" :disabled="loading" @click="deleteTv">
                                        Delete TV
                                        <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                                    </b-btn>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="hideEditTV" >
                                        Cancel
                                    </b-btn>
                                </b-col>
                            </b-row>
                        </template>
                    </c-modal>
                        <c-modal centered v-model="addTvMode" :tag="false" size="lg" title="Add Menu Board TV">
                        <template>
                            <b-container>
                                <b-alert :show="errors.any()" variant="danger" class="px-4">
                                    <ul class="m-0 px-1">
                                        <li v-for="err in errors.all()" :key="err">{{err}}</li>
                                    </ul>
                                </b-alert>
                                <b-row>
                                    <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                        <b-input-group prepend="Menu Board TV Name">
                                            <b-form-input class="text-center" type="text" name="tv Name" v-validate="'required'" v-model="newTVmodel.TVname" @change="()=>fillName = true"/>
                                        </b-input-group>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <b-input-group prepend="Display Theme">
                                                    <b-form-select
                                                    class="myFeild"
                                                    name="Display Theme"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.DisplayTemplate"
                                                    :options="themes"
                                                    placeholder="Select"
                                                    @change="()=>themeFilled = true"
                                                    >
                                                    <template #first>
                                                        <b-form-select-option :value="null||''">Select...</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                
                                    
                                    <b-row class="mt-3">
                                        <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                            <b-input-group prepend="Background Color" >
                                                <input type="color" v-model="newTVmodel.BackgroundColor" class="backgroundColor" name="color" value="#ffffff" />
                                            </b-input-group>
                                        </b-col>
                                            <b-col cols="12" md="6">
                                            <b-input-group prepend="Text Area Height(%)" >
                                                    <b-select
                                                        name="tvData"
                                                        v-validate="'required'"
                                                        v-model="newTVmodel.TextAreaPercentage"
                                                        value-field="value"
                                                        text-field="name"
                                                        :options="options.TextAreaHeights"/>
                                                </b-input-group >

                                        </b-col>
                                    </b-row>
                                
                                <b-row class="mt-2">
                                
                                    <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                            <b-row class="ml-1 mt-2 mb-2 ">Category Name</b-row>  
                                        
                                            <b-input-group prepend="Font Name" class="mt-2">
                                                <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.Category_FontName"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontNames"/>
                                            </b-input-group >
                                            
                                            <b-input-group prepend="Font Style" class="mt-2">
                                            <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.Category_FontStyle"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontStyles"/>
                                            </b-input-group >
                                    </b-col>
                                    
                                    <b-col cols="12" md="6">
                                        <b-form-group>
                                            <b-row class="ml-1 mt-2 mb-2">‎ </b-row> <!-- invisible character in this line -->
                                           
                                            <b-input-group prepend="Font Size" class="mt-2">
                                                    <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.Category_FontSize"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontSizes"/>
                                            </b-input-group>
                                            <b-input-group prepend="Font Color" class="mt-2">
                                                <input type="color" v-model="newTVmodel.Category_FontColor" id="color" name="color" value="#ffffff" />
                                            </b-input-group>

                                        </b-form-group>
                                    </b-col>
                               
                                </b-row> 
                                <b-row class="mt-2">
                                
                                    <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                            <b-row class="ml-1 mt-2 mb-2 ">Category Comment</b-row>  
                                        
                                            <b-input-group prepend="Font Name" class="mt-2">
                                                <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.CategoryComm_FontName"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontNames"/>
                                            </b-input-group >
                                            
                                            <b-input-group prepend="Font Style" class="mt-2">
                                            <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.CategoryComm_FontStyle"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontStyles"/>
                                            </b-input-group >
                                    </b-col>
                                    
                                    <b-col cols="12" md="6">
                                        <b-form-group>
                                            <b-row class="ml-1 mt-2 mb-2">‎ </b-row> <!-- invisible character in this line -->
                                           
                                            <b-input-group prepend="Font Size" class="mt-2">
                                                    <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.CategoryComm_FontSize"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontSizes"/>
                                            </b-input-group>
                                            <b-input-group prepend="Font Color" class="mt-2">
                                                <input type="color" v-model="newTVmodel.CategoryComm_FontColor" id="color" name="color" value="#ffffff" />
                                            </b-input-group>

                                        </b-form-group>
                                    </b-col>
                               
                                </b-row> 
                                <b-row class="mt-2">
                                
                                    <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                            <b-row class="ml-1 mt-2 mb-2 ">Food/Drink Information</b-row>  
                                        
                                            <b-input-group prepend="Font Name" class="mt-2">
                                                <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.Food_FontName"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontNames"/>
                                            </b-input-group >
                                            
                                            <b-input-group prepend="Font Style" class="mt-2">
                                            <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.Food_FontStyle"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontStyles"/>
                                            </b-input-group >
                                    </b-col>
                                    
                                    <b-col cols="12" md="6">
                                        <b-form-group>
                                            <b-row class="ml-1 mt-2 mb-2">‎ </b-row> <!-- invisible character in this line -->
                                           
                                            <b-input-group prepend="Font Size" class="mt-2">
                                                    <b-select
                                                    name="tvData"
                                                    v-validate="'required'"
                                                    v-model="newTVmodel.Food_FontSize"
                                                    value-field="value"
                                                    text-field="name"
                                                    :options="options.FontSizes"/>
                                            </b-input-group>
                                            <b-input-group prepend="Font Color" class="mt-2">
                                                <input type="color" v-model="newTVmodel.Food_FontColor" id="color" name="color" value="#ffffff" />
                                            </b-input-group>

                                        </b-form-group>
                                    </b-col>
                               
                                </b-row> 
                            </b-container>
                        </template>
                        <template #actions>
                            <b-row class="flex-grow-1">
                                <b-col cols="12" md="6" class="mb-2 mb-md-0">
                                    <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="addtv">
                                        Save change
                                        <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                                    </b-btn>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="hideAddTV" >
                                        Cancel
                                    </b-btn>
                                </b-col>
                            </b-row>
                        </template>
                    </c-modal>
                </b-card>
               <upload-photo
                    title="Background Image Upload"
                    first-content=""
                    hide-header
                    second-content=""
                    v-model="uploadImageMode"
                    :has-photo="!!editTvModel.BackgroundImage"
                    :ratio="16/9"
                    :vertical-ratio="9/16"
                    @upload="upload"
                    @delete="deletePhoto"
                    :progressing="loading"

                    >
                    <template #content>
                        <div class="font-weight-bold text-center" style="color: red">
                            Menu Board Background Image Update
                        </div>

                        <div class="mt-3 position-relative" v-if="editTvModel.BackgroundImage != ''">
                            <b-img fluid-grow :src="getBackgroundImage(editTvModel.BackgroundImage)" style="object-fit: contain; max-height: 60vh; max-width: 100%;"/>
                        </div>

                        <div class="mt-3 bg-secondary text-center font-weight-bold d-flex align-items-center justify-content-center" style="height: 300px; color: #a7a7a7" v-else>
                        No Background Image Available
                        </div>

                        <div class="mt-3 font-weight-bold h5">
                            Background Image Upload
                        </div>
                        <div class="mt-3">
                        Upload a jpg, png, or gif file under 20MB with the following sizes for best results:

                        </div>
                        <div> For horizontal (landscape) images, use images with 16:9 size aspect ratio (e.g. resolution 1920 by 1080 pixel) <br>
                                For vertical (portrait) images, use images with 9:16 size aspect ratio (e.g. resolution 1080 by 1920 pixel)
                        </div>
                        
      </template>
      </upload-photo>
            </b-container>
            </b-overlay>
        </div>
</template>

<script>
import CModal from "../../components/shared/Cmodal";
import Mlabel from "../../components/shared/Mlabel";
import config from 'SrcConfig'
import UploadPhoto from "../shared/UploadPhoto";
export default {
    name:'menuBoard',
    components:{
        CModal,
        Mlabel,
        UploadPhoto

    },
    data(){
        return{
            tvs:[],
            currentlySelectedTv:{},
            options:{
                FontNames:[{name:"Oswald", value:"Oswald"},{name:"Roboto", value:"Roboto"},{name:"Arial", value:"Arial"},{name:"Lato", value:"Lato"}],
                FontStyles:[{name:"Underlined", value:"Underlined"},{name:"Italic", value:"Italic"},{name:"Normal", value:"Normal"},{name:"Bold", value:"Bold"}],
                FontSizes:[
                    {name:"10", value:10},
                    {name:"11", value:11},
                    {name:"12", value:12},
                    {name:"13", value:13},
                    {name:"14", value:14},
                    {name:"15", value:15},
                    {name:"16", value:16},
                    {name:"17", value:17},
                    {name:"18", value:18},
                    {name:"19", value:19},
                    {name:"20", value:20},
                    {name:"21", value:21},
                    {name:"22", value:22}],
                    TextAreaHeights:[
                        {name:"100%", value:100.0},
                        {name:"95%", value:95.0},
                        {name:"90%", value:90.0},
                        {name:"85%", value:85.0},
                        {name:"80%", value:80.0},
                        {name:"75%", value:75.0},
                        {name:"70%", value:70.0},
                        {name:"65%", value:65.0},
                        {name:"60%", value:60.0},
                        {name:"55%", value:55.0},
                        {name:"50%", value:50.0},
                        {name:"45%", value:45.0},
                        {name:"40%", value:40.0},
                        {name:"35%", value:35.0},
                        {name:"30%", value:30.0},
                        {name:"25%", value:25.0},
                        {name:"20%", value:20.0},
                        {name:"15%", value:15.0},
                        {name:"10%", value:10.0},
                        {name:"5%", value:5.0},
                    ],
                
            },
            editTvMode:false,
            editTvModel:{},
            addTvMode:false,
            newTVmodel:{
                TVid:0,
                TVname:"",
                BackgroundColor:"#edeef8",
                Category_FontName:"Oswald",
                Category_FontStyle:"Bold",
                Category_FontSize:19,
                Category_FontColor:"#ff5622",
                CategoryComm_FontName:"Oswald",
                CategoryComm_FontStyle:"Normal",
                CategoryComm_FontSize:13,
                CategoryComm_FontColor:"#0ca10c",
                Food_FontName:"Roboto",
                Food_FontStyle:"Bold",
                Food_FontSize:18,
                Food_FontColor:"#800020",
                DisplayTemplate: null,
                TextAreaPercentage:100.0,
            },
            loading:false,
            fillName:true,
            themeFilled:true,
            showTemplateChange:false,
            editTemplate:"",
            themes:["H Classic 3-Column","H Classic 2-Column","H Classic 1-Column", "V Classic 1-Column"],
            uploadImageMode:false,
        }
    },
    created(){
        this.getTvs()
    },
    methods:{
        getTVLink(url){
            return config.apiServerUrl.replace("/api", "") + url
        },
        changeTemplateVisibility(){
            this.showTemplateChange = !this.showTemplateChange
        },
        addtv(){
            let hasError = false
            if(!this.fillName){
                this.newTVmodel.TVname = " "//changing value manually to trigger v-validate and show default error
                setTimeout(()=>{
                    this.newTVmodel.TVname = ""
                },1)
                hasError = true
            }
            if(!this.themeFilled){
                this.newTVmodel.DisplayTemplate = "x"//changing value manually to trigger v-validate and show default error
                setTimeout(()=>{
                    this.newTVmodel.DisplayTemplate = null
                },1)
                hasError = true
            }
            if(hasError){
                return
            }
            this.loading = true
            this.$api.getRestaurant.UpdateRestaurantMenuboardTV({UserID:localStorage.getItem("restaurantProfile") ,RestaurantID: this.$store.state.selectedRestaurantId ,...this.newTVmodel}).then(res=>{
                if(res.success){
                    this.hideAddTV()
                    this.getTvs()
                }else{
                    this.$showError("Something went wrong. please try again later")
                }
                this.loading = false
            })
            
        },
        editTV(){
            this.loading = true
            this.$api.getRestaurant.UpdateRestaurantMenuboardTV({UserID:localStorage.getItem("restaurantProfile") ,RestaurantID: this.$store.state.selectedRestaurantId ,...this.editTvModel}).then(res=>{
                if(res.success){
                    this.hideEditTV()
                    this.getTvs()
                }else{
                    this.$showError("Something went wrong. please try again later")
                }
                this.loading = false
            })
        },
        deleteTv(){
            this.loading = true
            this.$api.getRestaurant.DeleteMenuboardTVDisplayTemplate({UserID:localStorage.getItem("restaurantProfile") ,RestaurantID: this.$store.state.selectedRestaurantId ,TVid:this.editTvModel.TVid}).then(res=>{
                if(res.success){
                    this.hideEditTV()
                    this.getTvs()
                }else{
                    this.$showError("Something went wrong. please try again later")
                }
                this.loading = false
            })
        },
        getTvs(){
            this.loading = true
                const model = {
                TVid:-1,
                    RestaurantID:localStorage.getItem("selectedRestaurant")
            }
            this.$api.getRestaurant.GetRestaurantMenuboardTVs(model).then(res => {
                if (res.success) {
                    this.tvs = res.menuBoards
                }
                this.loading = false
            })
        },
        getPresetTv(){
            if(!this.tvs.length){
                return null
            }
            return this.tvs.reduce((highest, item) => item.TVid > highest.TVid ? item : highest, this.tvs[0])
        },
        showAddTV(){
            this.addTvMode = true
            this.fillName = false
            this.themeFilled = false
            const preset = this.getPresetTv()
            if(preset){
                this.newTVmodel.BackgroundColor = preset.BackgroundColor
                this.newTVmodel.Category_FontName = preset.Category_FontName
                this.newTVmodel.Category_FontStyle = preset.Category_FontStyle
                this.newTVmodel.Category_FontSize = preset.Category_FontSize
                this.newTVmodel.Category_FontColor = preset.Category_FontColor
                this.newTVmodel.CategoryComm_FontName = preset.CategoryComm_FontName
                this.newTVmodel.CategoryComm_FontStyle = preset.CategoryComm_FontStyle
                this.newTVmodel.CategoryComm_FontSize = preset.CategoryComm_FontSize
                this.newTVmodel.CategoryComm_FontColor = preset.CategoryComm_FontColor
                this.newTVmodel.Food_FontName = preset.Food_FontName
                this.newTVmodel.Food_FontStyle = preset.Food_FontStyle
                this.newTVmodel.Food_FontSize = preset.Food_FontSize
                this.newTVmodel.Food_FontColor = preset.Food_FontColor
                this.newTVmodel.TextAreaPercentage = preset.TextAreaPercentage
            }
        },
        showEditMode(tvid){
            this.loading = true
            const model = {
                TVid:tvid,
                    RestaurantID:localStorage.getItem("selectedRestaurant")
            }
            
            this.$api.getRestaurant.GetRestaurantMenuboardTVs(model).then(res => {
                if (res.success) {
                    this.editTvModel = res.menuBoards[0]
                    this.editTvMode = true
                    this.editTemplate = this.editTvModel.DisplayTemplate
                }else{
                    this.$showError("Something went wrong. please try again later")
                    this.editTvMode = true

                }
                this.loading = false
            })

        },
        hideEditTV(){
            this.editTvMode = false
            this.editTvModel={}
            this.showTemplateChange = false
        },
        hideAddTV(){
            this.addTvMode = false
            this.newTVmodel = {
                TVid:0,
                TVname:"",
                BackgroundColor:"#ffffff",
                Category_FontName:"Oswald",
                Category_FontStyle:"Underlined",
                Category_FontSize:15,
                Category_FontColor:"#000000",
                CategoryComm_FontName:"Oswald",
                CategoryComm_FontStyle:"Italic",
                CategoryComm_FontSize:13,
                CategoryComm_FontColor:"#B2BEB5",
                Food_FontName:"Roboto",
                Food_FontStyle:"Normal",
                Food_FontSize:12,
                Food_FontColor:"#000000",
                DisplayTemplate: null,
                TextAreaPercentage:100.0,
                }
        },
        getBackgroundImage(image){
            let baseUrl = config.files.baseurlimage;
        if (config.files.baseurlimage.search('www') != -1) {
          baseUrl = "https://images.menupoly.com";
        }
        return baseUrl + `/UserUpload/User_${localStorage.getItem('restaurantProfile')}/` + image 
        },
        selectBackgroundImage(){
            this.uploadImageMode = true
        },
        deletePhoto () {
        const model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
        }
        this.progressing = true
        return this.$api.getRestaurant.DeleteMenuboardBackground(model, this.editTvModel.TVid, true).then(() => {
          this.progressing = false
          this.uploadImageMode = false
          this.editTvModel.BackgroundImage = ''
        }).catch(() => {
          this.$showError('error on delete photo')
        })

      },
        upload ({image, fileName, vertical}) {
           this.loading = true
            const splitedImage = image.split(',')[1]
            const model = {
                RestaurantID: this.$store.state.selectedRestaurantId,
                FileName: fileName,
                Photo: splitedImage,
            }
            console.log(model, this.editTvModel.TVid)
            return this.$api.getRestaurant.UploadMenuboardBackground(model, this.editTvModel.TVid, true).then((res) => {
            
                    this.uploadImageMode = false
                    this.editTvModel.BackgroundImage = res.data
                    this.loading = false
                
            }).catch(() => {
                this.uploadImageMode = false
                this.loading = false
            this.$showError('error on upload photo')
            })
            
      },

    }
}
</script>

<style lang="css">
#color{
    height: 2.2rem;
}
.backgroundColor{
    height: 2.2rem;
    width: 6rem;
}
.backgroundImageThumbnail{
    width: 6rem;
    height: 2.2rem;
    object-fit: cover;
}
.tv-table .tv-table-cell{
    word-break: break-word;
    overflow-wrap: anywhere;
}
.tv-table .tv-link-cell a{
    word-break: break-all;
    overflow-wrap: anywhere;
    display: inline-block;
}
@media (max-width: 575.98px){
    .tv-table{
        font-size: 0.8rem;
    }
    .tv-table th,
    .tv-table td{
        padding: 0.5rem 0.4rem;
    }
    .tv-table .tv-link-cell a{
        max-width: 9rem;
    }
}

</style>